import React, { useState, useEffect } from "react";
import { Modal,Select, Typography, Button, Input } from "antd";
import * as orderManagementActions from "../../../../../../redux/actions/orderManagement.actions";
import * as cancellationReasonActions from "../../../../../../redux/actions/cancellationReason.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Pageloader from "../../../../../../components/loader";
const { TextArea } = Input;
const { Text } = Typography;
const { Option } = Select;
const plainOptionsreason = [
  {label: "Customer cancellation", value: "Customer cancellation"},
  {label: "Law and order", value: "Law and order"},
  {label: "Logistic cancellation", value: "Logistic cancellation"},
  {label: "Partial order cancellation", value: "Partial order cancellation"},
  {label: "Suspected retailer", value: "Suspected retailer"},
  {label: "Technical Issue", value: "Technical Issue"},
  {label: "Test Cancellation", value: "Test Cancellation"},
  {label: "Mart Cancellation", value: "Mart Cancellation"},
];

const OrderCancel = (props) => {
  const [MBtnLoading, setMBtnLoading] = useState(false);
  const [postDataReason, setPostDataReason] = useState(null);
  const [Comment, setComment] = useState(null);
  const [loading, setLoading] = useState(false);
  const [cancellationReason, setCancellationReason] = useState(null);

  useEffect(() => {
    cancellationReasonList()
  }, [])
  useEffect(() => {
    if (props.cancellationReasonData){
      setCancellationReason(props.cancellationReasonData)
    }
  }, [props.cancellationReasonData])

  const cancellationReasonList = async () => {
    try {
      setLoading(true);
      await props.cancellationReasonActions.cancellationReasonListAction();
    } catch (e) {} finally {
      setLoading(false);
    }
  }
  const statusReason = (Value) => {
    setPostDataReason(Value);
  };
  // const setCommentFunctionOnchange = (val) => {
  //   setComment(val);
  // };
  const statusSubmit = async () => {
    try {
      setMBtnLoading(true);
      await props.orderManagementActions.updateOrderStatusAction({
        orderId: props.overviewdashboardid,
        statusSlug: "cancel",
        confirmCancel: true,
        reason: postDataReason,
        comment: Comment,
      },"Order Cancel")
    } catch (e) {} finally {
      setMBtnLoading(false);
      props.setvisible(false);
      props.postListsrefresh();
    }
  };
  const handleCancel = () => {props.setvisible(false)};

  return (
    <Modal
      title="Cancel Order"
      visible={props.visible}
      onCancel={handleCancel}
      footer={[
        <Button onClick={handleCancel}>Cancel </Button>,
        <Button loading={MBtnLoading} onClick={statusSubmit} disabled={postDataReason == null}>Order Cancel</Button>,
      ]}
    >
      <Text>Please select cancellation reason</Text>
      {loading ? (
        <Pageloader />
      ) : (
        <Select showSearch style={{ width: "100%" }} onChange={statusReason}>
          {cancellationReason &&
            cancellationReason.map((item) => (
              <Option key={item.value} value={item.value}>{item.value}</Option>
            ))}
        </Select>
      )}

      {/* <Select style={{ width: "100%" }} onChange={statusReason}>
        {plainOptionsreason &&
          plainOptionsreason.map((item) => (
            <Option key={item.value} value={item.value}>{item.label}</Option>
          ))}
      </Select> */}
      {/* <Text>Comment</Text>
      {loading ? (
        <Pageloader />
      ) : (
        <Select showSearch style={{ width: "100%" }} onChange={setCommentFunctionOnchange}>
          {cancellationReason &&
            cancellationReason.map((item) => (
              <Option key={item.value} value={item.value}>{item.value}</Option>
            ))}
        </Select>
      )} */}
    </Modal>
  );
};
const mapStateToProps = (state) => {
  return {
    cancellationReasonData: state.CancellationReasonReducer.initialData,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    orderManagementActions: bindActionCreators(orderManagementActions, dispatch),
    cancellationReasonActions: bindActionCreators(cancellationReasonActions, dispatch),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(OrderCancel);
